export enum GpsTrackingNumberType {
    OutboundTrackingNumber = 1,
    ReturnTrackingNumber = 2
}